export { ReactComponent as Calendar } from "./calendar.svg";
export { ReactComponent as Clock } from "./clock.svg";
export { ReactComponent as Copy } from "./copy.svg";
export { ReactComponent as Discovery } from "./discovery.svg";
export { ReactComponent as DownSquare } from "./down-square.svg";
export { ReactComponent as Download } from "./download.svg";
export { ReactComponent as Eye } from "./eye.svg";
export { ReactComponent as EyeClosed } from "./eye-closed.svg";
export { ReactComponent as MenuAdditional } from "./menu-additional.svg";
export { ReactComponent as MenuCourses } from "./menu-courses.svg";
export { ReactComponent as MenuLessons } from "./menu-lessons.svg";
export { ReactComponent as MenuLexis } from "./menu-lexis.svg";
export { ReactComponent as MenuLinks } from "./menu-links.svg";
export { ReactComponent as MenuMain } from "./menu-main.svg";
export { ReactComponent as MenuNotifications } from "./menu-notifications.svg";
export { ReactComponent as MenuTeacher } from "./menu-teacher.svg";
export { ReactComponent as MenuVideo } from "./menu-video.svg";
export { ReactComponent as MenuAttendance } from "./menu-attendance.svg";
export { ReactComponent as RightSquare } from "./right-square.svg";
export { ReactComponent as Trash } from "./trash.svg";
export { ReactComponent as TickCircleActive } from "./tick-circle-active.svg";
export { ReactComponent as TickCircleDone } from "./tick-circle-done.svg";
export { ReactComponent as TickCircle } from "./tick-circle.svg";
export { ReactComponent as UpSquare } from "./up-square.svg";
export { ReactComponent as VideoSlash } from "./video-slash.svg";
export { ReactComponent as Video } from "./video.svg";
export { ReactComponent as MobileMenuBurger } from "./mobile-menu-burger.svg";
export { ReactComponent as MobileMenuClose } from "./mobile-menu-close.svg";
export { ReactComponent as MobileMenuBack } from "./mobile-menu-back.svg";
export { ReactComponent as Notification } from "./notification.svg";
export { ReactComponent as InputError } from "./input-error.svg";
export { ReactComponent as InputEmail } from "./input-email.svg";
export { ReactComponent as InputEyeClose } from "./input-eye-close.svg";
export { ReactComponent as InputEyeOpen } from "./input-eye-open.svg";
export { ReactComponent as InputPassword } from "./input-password.svg";
export { ReactComponent as InputPerson } from "./input-person.svg";
export { ReactComponent as InputSearch } from "./input-search.svg";
export { ReactComponent as SelectDown } from "./select-down.svg";
export { ReactComponent as SelectUp } from "./select-up.svg";
export { ReactComponent as SortDirection } from "./sort-direction.svg";
export { ReactComponent as PhoneKir } from "./phone-kir.svg";
export { ReactComponent as PhoneRus } from "./phone-rus.svg";
export { ReactComponent as PhoneTjk } from "./phone-tjk.svg";
export { ReactComponent as PhoneTkm } from "./phone-tkm.svg";
export { ReactComponent as PhoneUzb } from "./phone-uzb.svg";
export { ReactComponent as BackSquare } from "./back-square.svg";
export { ReactComponent as LogoRus } from "./logo-rus.svg";
export { ReactComponent as LogoEng } from "./logo-eng.svg";
export { ReactComponent as SelectArrows } from "./select-arrows.svg";
export { ReactComponent as CheckboxCheck } from "./checkbox-check.svg";
export { ReactComponent as PrevArrow } from "./prev-arrow.svg";
export { ReactComponent as NextArrow } from "./next-arrow.svg";
export { ReactComponent as Display } from "./display.svg";
export { ReactComponent as Back } from "./back.svg";
export { ReactComponent as CloseModal } from "./close-modal.svg";
export { ReactComponent as Envelope } from "./envelope.svg";
export { ReactComponent as ExerciseGrammar } from "./exercise-grammar.svg";
export { ReactComponent as ExerciseReading } from "./exercise-reading.svg";
export { ReactComponent as ExerciseSpeaking } from "./exercise-speaking.svg";
export { ReactComponent as ExerciseVideo } from "./exercise-video.svg";
export { ReactComponent as ExerciseVocabulary } from "./exercise-vocabulary.svg";
export { ReactComponent as ExerciseWritting } from "./exercise-writting.svg";
export { ReactComponent as ArrowUp } from "./arrow-up.svg";
export { ReactComponent as ArrowDown } from "./arrow-down.svg";
export { ReactComponent as Filters } from "./filters.svg";
export { ReactComponent as CloseFilters } from "./close-filters.svg";
export { ReactComponent as Sound } from "./sound.svg";
export { ReactComponent as WordCheck } from "./word-check.svg";
export { ReactComponent as Profile } from "./profile.svg";
export { ReactComponent as TaskMicro } from "./task-micro.svg";
export { ReactComponent as TaskBook } from "./task-book.svg";
export { ReactComponent as TaskBookAlt } from "./task-book-alt.svg";
export { ReactComponent as Accordion } from "./accordion.svg";
export { ReactComponent as Grammar } from "./grammar.svg";
export { ReactComponent as Vocubalury } from "./vocubalury.svg";
export { ReactComponent as Comments } from "./comments.svg";
export { ReactComponent as arrowRight } from "./arrow-right.svg";
export { ReactComponent as UsefulLinkVariant1 } from "./useful-link-variant-1.svg";
export { ReactComponent as UsefulLinkVariant2 } from "./useful-link-variant-2.svg";
export { ReactComponent as UsefulLinkVariant3 } from "./useful-link-variant-3.svg";
export { ReactComponent as UsefulLinkVariant4 } from "./useful-link-variant-4.svg";
export { ReactComponent as ArrowRight } from "./arrow-right.svg";
export { ReactComponent as Groups } from "./group.svg";
export { ReactComponent as Call } from "./call.svg";
export { ReactComponent as ArrowBack } from "./arrow-back.svg";
export { ReactComponent as Stats } from "./stats.svg";
